const initialState = {
  page: 1,
  pageSize: 20,
  total: 0,
  totalPages: 100,
};

const workflows = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_WORKFLOWS':
    return {
      ...state,
      data: action.data.data,
      paginationMeta: {
        page: action.data.page,
        pageSize: action.data.pageSize,
        total: action.data.total,
        totalPages: action.data.totalPages,
      },
    };
  default:
    return { ...state };
  }
};

export default workflows;
